import {isDev} from "@/api/config";

let kakaoScript = null;
let kakaoKey = "25fbaaf5bb9439c7f93e4f45414583f8";
let kakaoKeyDev = "384e3d77ca88695bbd7f2462316118bf";
const getKakaoKey = () => isDev ? kakaoKeyDev : kakaoKey;
// 카카오싱크 간편가입 동의창(서비스 약관 포함)은 인가코드 방식(authorize)이 필요해 JS SDK v2를 사용한다
const scriptUrlKakao = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js";
const redirectPath = '/auth/kakao/callback';

const loadSdk = () => {
    return new Promise((resolve, reject) => {
        if (window.Kakao) {
            if (!window.Kakao.isInitialized()) {
                window.Kakao.init(getKakaoKey());
            }
            resolve();
            return;
        }
        kakaoScript = document.createElement('script');
        kakaoScript.src = scriptUrlKakao;
        kakaoScript.onload = () => {
            window.Kakao.init(getKakaoKey());
            resolve();
        };
        kakaoScript.onerror = reject;
        document.body.appendChild(kakaoScript);
    });
};

export const kakaoService = () => {
    const initService = () => {
        loadSdk();
    };
    // 카카오 로그인(간편가입 동의창)으로 전체 페이지 리다이렉트.
    // redirectUri 는 도메인별로 카카오 콘솔에 등록되어 있어야 한다(미등록 시 KOE006).
    const authorize = () => {
        loadSdk().then(() => {
            Kakao.Auth.authorize({
                redirectUri: window.location.origin + redirectPath,
            });
        });
    };
    // 인가코드 → 토큰 교환. 백엔드 소셜 로그인 계약(access_token 전달)을 유지하기 위해
    // 프론트에서 교환한다(JS 키는 브라우저 교환 허용).
    const exchangeToken = (code) => {
        const body = new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: getKakaoKey(),
            redirect_uri: window.location.origin + redirectPath,
            code: code,
        });
        return fetch('https://kauth.kakao.com/oauth/token', {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'},
            body: body,
        }).then((res) => res.json()).then((data) => {
            if (data.error) {
                throw data;
            }
            // unlink/logout 등 이후 SDK 호출을 위해 토큰을 SDK 에도 설정
            return loadSdk().then(() => {
                Kakao.Auth.setAccessToken(data.access_token);
                return data;
            });
        });
    };
    const kakaoLogout = () => {
        loadSdk().then(() => {
            Kakao.Auth.logout()
                    .then(function () {
                        alert('logout ok\naccess token -> ' + Kakao.Auth.getAccessToken());
                        deleteCookie();
                    })
                    .catch(function () {
                        alert('Not logged in');
                    });
        });
    };
    const disconnect = (afterFunc = () => {
    }) => {
        loadSdk().then(() => {
            return Kakao.API.request({url: '/v1/user/unlink'});
        }).then((response) => {
            afterFunc(response);
        }).catch((error) => {
            console.log(error);
            afterFunc(error);
        });
    };
    return {
        initService,
        authorize,
        exchangeToken,
        disconnect,
        kakaoLogout
    }
}
